import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Grid,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import { ReactComponent as ArrowDown } from "assets/images/ArrowDown.svg";
import CommonModal from "components/shared/common-modal/CommonModal";
import { useFormik } from "formik";
import { t } from "i18next";
import { useEffect, useState } from "react";
import spacing from "styles/spacing";
import { runManagementStyles } from "./RunManagementStyle";
import { getCustomerList } from "./helper";

const FindCustomerModal = (props) => {
  const {
    isShowFindCustomerModal,
    setIsShowFindCustomerModal,
    setThrowError,
    runTreeData,
    openCustomer
  } = props;

  const initalRunState = {
    customer: null
  };

  const runForm = useFormik({
    initialValues: initalRunState
  });

  const [customerData, setCustomerData] = useState([]);

  useEffect(() => {
    let customerList = getCustomerList(runTreeData);
    setCustomerData(customerList);
    //eslint-disable-next-line
  }, []);

  const handleCancelClick = () => {
    setThrowError(false);
    setIsShowFindCustomerModal(false);
  };

  const handleApplyClick = () => {
    openCustomer(runForm.values.customer);
    setIsShowFindCustomerModal(false);
  };

  return (
    <>
      <CommonModal
        open={isShowFindCustomerModal}
        title={t("runManagement.findCustomerTitle")}
        body={
          <Stack direction="column">
            <Grid container spacing={spacing.gap}>
              <Grid item xs={12} sx={runManagementStyles.autoCompleteStyle}>
                <Autocomplete
                  componentsProps={{
                    clearIndicator: ArrowDown
                  }}
                  popupIcon={<ArrowDown />}
                  clearIcon={<CloseIcon />}
                  options={customerData}
                  size="medium"
                  fullWidth
                  open={true}
                  ListboxProps={runManagementStyles.autoCompleteListStyle}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("runManagement.assignedCustomers")}
                    />
                  )}
                  onChange={(e, newValue) => {
                    runForm.setFieldValue("customer", newValue?.split(" ")[0]);
                  }}
                />
              </Grid>
            </Grid>
            <Typography component="small" sx={runManagementStyles.countStyle}>
              {t("runManagement.count")}: {customerData.length}
            </Typography>
          </Stack>
        }
        buttons={
          <>
            <Button variant="outlined" onClick={handleCancelClick}>
              {t("common.cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={handleApplyClick}
              disabled={!runForm.values.customer}
            >
              {t("common.apply")}
            </Button>
          </>
        }
      />
    </>
  );
};

export default FindCustomerModal;
